import * as z from 'zod';

export const VenueSchema = z.object({
  name: z.string(),
  capacity: z.number().nullable(),
});

export const RefereeSchema = z.object({
  name: z.string(),
  flag: z.string().nullable(),
});

const OtherInfoSchema = z.object({
  venue: VenueSchema.nullable(),
  referee: RefereeSchema.nullable(),
});

export default OtherInfoSchema;
